import { PublicURL } from "./PublicURL";
import GuestPageWrapper from "../../components/page_wrappers/GuestPageWrapper";

// import HomePage from "../../pages/public_pages/HomePage";
import HP3dDesign from "../../pages/public_pages/HP3dDesign";
import UploadDocument from "../../pages/user_pages/UploadDocument";

import AboutUs from "../../pages/public_pages/company/AboutUs";
import Careers from "../../pages/public_pages/company/Careers";
import Contact from "../../pages/public_pages/company/Contact";
import Vision from "../../pages/public_pages/company/Vision";
import Analytics from "../../pages/public_pages/solutions/Analytics";
import Automation from "../../pages/public_pages/solutions/Automation";
import Integrations from "../../pages/public_pages/solutions/Integrations";
import Workflows from "../../pages/public_pages/solutions/Workflows";

const routeConfigs = [
    // { path: PublicURL.HOME, component: HomePage },
    { path: PublicURL.HOME,         component: HP3dDesign },
    { path: PublicURL.ABOUT_US,     component: AboutUs },
    { path: PublicURL.CAREERS,      component: Careers, wrapPage: true },
    { path: PublicURL.CONTACT_US,   component: Contact },
    { path: PublicURL.VISION,       component: Vision },
    { path: PublicURL.ANALYTICS,    component: Analytics },
    { path: PublicURL.AUTOMATION,   component: Automation },
    { path: PublicURL.INTEGRATIONS, component: Integrations },
    { path: PublicURL.WORKFLOWS,    component: Workflows },

    { path: PublicURL.UPLOAD_REQUESTED_DOCUMENT, component: UploadDocument, wrapPage: true },
];

const PublicRoutes = routeConfigs.map( 
    ({ path, component: Component, wrapPage = false }) => ({
        path,
        element: wrapPage ? (
            <GuestPageWrapper>
                <Component />
            </GuestPageWrapper>
        ) : (
            <Component />
        )
    })
);

export default PublicRoutes;
